/* v8 ignore start */
interface IClientResponse<T> {
  status: number;
  data: T;
  headers: Headers;
  url: string;
}

export async function client<T>(
  endpoint: string,
  {token, body, method, ...customConfig}: Partial<RequestInit & {token?: string}> = {}
): Promise<IClientResponse<T>> {
  const headers = {"Content-Type": "application/json"};

  const config: RequestInit = {
    method,
    ...customConfig,
    headers: {
      ...headers,
      ...(token ? {Authorization: `Bearer ${token}`} : {}),
      ...customConfig.headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  let data;
  try {
    const response = await fetch(endpoint, config);
    data = await response.json();
    if (response.ok) {
      // Return a result object similar to Axios
      return {
        status: response.status,
        data,
        headers: response.headers,
        url: response.url,
      };
    }
    throw new Error(response.statusText);
  } catch (err: any) {
    return Promise.reject(err.message ? err.message : data);
  }
}

client.get = function <T>(endpoint: string, customConfig: Partial<RequestInit & {token?: string}> = {}) {
  return client<T>(endpoint, {...customConfig, method: "GET"});
};

client.post = function <T>(endpoint: string, body: any, customConfig: Partial<RequestInit & {token?: string}> = {}) {
  return client<T>(endpoint, {...customConfig, method: "POST", body});
};

client.put = function <T>(endpoint: string, body: any, customConfig: Partial<RequestInit & {token?: string}> = {}) {
  return client<T>(endpoint, {...customConfig, method: "PUT", body});
};
/* v8 ignore stop */
